import React from 'react';
import { TOI_IMAGE_DOMAIN } from 'constants/index';
// import NewsletterSubscriptionPopup from 'components_v2/common/NewsletterCard/NewsletterSubscriptionPopup';
import Morebtn from '../../../components_v2/desktop/Morebtn';
import s from './Newsletter.scss';

const NewsletterBanner = props => {
  const {
    subscribeAllCallback,
    unsubscribeAllCallback,
    showUnsubscribeAllBtn,
  } = props;

  return (
    <>
      <div className={s.newsLetterBanner}>
        <img
          src={`${TOI_IMAGE_DOMAIN}/photo/121670974.cms`}
          alt="Newsletter Banner"
          className={s.onlyWeb}
        />
        <img
          className={s.onlyWap}
          src={`${TOI_IMAGE_DOMAIN}/photo/121770954.cms`}
          alt="Newsletter Banner"
        />

        <div>
          <h3>
            {showUnsubscribeAllBtn
              ? "You're now subscribed to all newsletters! Fresh updates and stories will land in your inbox soon!"
              : 'Stay on Top of Everything!'}
          </h3>
          {!showUnsubscribeAllBtn && (
            <p>
              Subscribe to all our newsletters for the latest updates, exclusive
              content, and much more, straight to your inbox!
            </p>
          )}
          {!showUnsubscribeAllBtn && (
            <div className={`${s.onlyWap}`}>
              <Morebtn
                moreText={
                  showUnsubscribeAllBtn
                    ? 'Unsubscribe from All'
                    : 'Subscribe to All'
                }
                redbg
                noArrow
                onClick={() => {
                  if (
                    !showUnsubscribeAllBtn &&
                    subscribeAllCallback &&
                    typeof subscribeAllCallback === 'function'
                  ) {
                    subscribeAllCallback();
                  }
                  if (
                    showUnsubscribeAllBtn &&
                    unsubscribeAllCallback &&
                    typeof unsubscribeAllCallback === 'function'
                  ) {
                    unsubscribeAllCallback();
                  }
                }}
              />
            </div>
          )}
        </div>
        {!showUnsubscribeAllBtn && (
          <div className={`${s.onlyWeb} ${s.MLauto}`}>
            <Morebtn
              moreText={
                showUnsubscribeAllBtn
                  ? 'Unsubscribe from All'
                  : 'Subscribe to All'
              }
              redbg
              noArrow
              onClick={() => {
                if (
                  !showUnsubscribeAllBtn &&
                  subscribeAllCallback &&
                  typeof subscribeAllCallback === 'function'
                ) {
                  subscribeAllCallback();
                }
                if (
                  showUnsubscribeAllBtn &&
                  unsubscribeAllCallback &&
                  typeof unsubscribeAllCallback === 'function'
                ) {
                  unsubscribeAllCallback();
                }
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default NewsletterBanner;
